import classes from "./styles.module.scss";
import clsx from "classnames";
import { DynamicText } from "@/ui/DynamicText";
import { DynamicHtml } from "@/ui/DynamicHtml";
import ArrowRight from "@/assets/ArrowRight.svg";
import Image from "@/ui/Image";

export const CtaCard = ({ className, title, text, url }) => {
  return (
    <a
      className={clsx(className, classes.cta, "text-overlay")}
      href={url}
      target={url.startsWith("http") ? "_blank" : "_self"}
    >
      <Image
        className="text-overlay__background"
        img={{ path: "component.cta.bg", src: "/assets/cta/default.png" }}
        size="626x220"
        alt=""
      />
      <div className="text-overlay__content">
        <i>
          <ArrowRight />
        </i>
        <div className={clsx(classes.cta__content, "p-4 pe-5 me-5")}>
          <DynamicText path={title.path} tag="h3" className="h5" />
          <DynamicHtml path={text.path} />
        </div>
      </div>
    </a>
  );
};
